export default __webpack_public_path__ + "static/media/P470MAND1.4c880548.pdf";